import React, { useEffect, useState } from "react";
import styles from "./mythViewer.module.css";
import { useHistory, useParams } from "react-router";
import MythMachine from "./mythMachine/MythMachine";
import { loadImage } from "../mythMaker/mythImageEditor/helpers";
import { useWindowSize } from "../../hooks/useWindowSize";

export default function MythViewer({ mythData }) {
  const history = useHistory();
  const { id } = useParams();

  const currMyth = mythData.find((m) => m.id === id);
  const onBgClick = () => history.push("/map");

  if (!currMyth)
    return (
      <div className={styles.overlayBg} onClick={onBgClick}>
        LOADING...
      </div>
    );

  return <CurrMythScreen currMyth={currMyth} onBgClick={onBgClick} />;
}

const CurrMythScreen = ({ currMyth, onBgClick }) => {
  const [comicImg, setComicImg] = useState(null);
  const [placeImg, setPlaceImg] = useState(null);
  const windowSize = useWindowSize();

  useEffect(() => {
    const { comicPhoto, placePhoto } = currMyth;
    let comicSrc = null;

    if (comicPhoto.url || comicPhoto.editedUrl) {
      comicSrc = comicPhoto.editedUrl ? comicPhoto.editedUrl : comicPhoto.url;
    }

    if (!comicImg && comicSrc) {
      loadImage(comicSrc, setComicImg, false);
    }

    if (!placeImg && placePhoto.url) {
      loadImage(placePhoto.url, setPlaceImg, false);
    }
    // eslint-disable-next-line
  }, [currMyth, comicImg, placeImg]);

  let viewType = "desktop";

  if (windowSize && windowSize.width) {
    const { width, height } = windowSize;

    if (width < 830) {
      viewType = width < height ? "mobilePortrait" : "mobileLandscape";
    }
  }

  return (
    <div className={styles.mythViewer}>
      <div className={styles.overlayBg} onClick={onBgClick} />
      <MythMachine
        currMyth={currMyth}
        comicCanvas={comicImg}
        placeCanvas={placeImg}
        viewType={viewType}
      />
    </div>
  );
};
